export enum ActionType {
  // Cache
  CACHE__REGENERATE_ALL_STATIC_PAGES = "CACHE__REGENERATE_ALL_STATIC_PAGES",

  // JobPost
  JOB_POST__CREATE = "JOB_POST__CREATE",
  JOB_POST__UPDATE = "JOB_POST__UPDATE",
  JOB_POST__SET_META = "JOB_POST__SET_META",
  JOB_POST__SET_HIRING_ORGANISATION = "JOB_POST__SET_HIRING_ORGANISATION",
  JOB_POST__SET_SOURCING_ORGANISATION = "JOB_POST__SET_SOURCING_ORGANISATION",
  JOB_POST__CHANGE_OWNER = "JOB_POST__CHANGE_OWNER",
  JOB_POST__INDEX = "JOB_POST__INDEX",
  JOB_POST__UNINDEX = "JOB_POST__UNINDEX",
  JOB_POST__APPROVE = "JOB_POST__APPROVE",
  JOB_POST__STOP = "JOB_POST__STOP",
  JOB_POST__RESUME = "JOB_POST__RESUME",
  JOB_POST__DELETE = "JOB_POST__DELETE",

  // Organisation
  ORGANISATION__UPSERT = "ORGANISATION__UPSERT",
  ORGANISATION__DELETE = "ORGANISATION__DELETE",

  // Order
  ORDER__CAPTURE_PAYMENT = "ORDER__CAPTURE_PAYMENT",
  ORDER__CANCEL_PAYMENT = "ORDER__CANCEL_PAYMENT",
  ORDER__CREATE_INVOICE = "ORDER__CREATE_INVOICE",
  ORDER__EMAIL_INVOICE = "ORDER__EMAIL_INVOICE",

  // Twitter
  TWITTER__TWEET_JOB_POST = "TWITTER__TWEET_JOB_POST",
}
